<template>
  <div>
    <div style="padding-bottom: 60px">
      <div style="padding-bottom: 30px">
        <p class="navadno-besedilo">
          Prej ko postanete član/ica, več točk boste zbrali in prej boste lahko uživali ugodnosti, ki jih
          prinašajo točke!
          <br/>
          Včlanite se in preverite ugodnosti, ki prepričajo. Članstvo v T-2 Klubu je brezplačno.
        </p>
      </div>
      <div style="padding-bottom: 35px" class="navadno-besedilo">
        <el-checkbox v-model="vclanitev"/>
        <b class="primarna-barva">
          DA,
        </b> želim postati član T-2 Kluba in sem prebral ter se strinjam s splošnimi pogoji, ki so dostopni
        <a :href="splosniPogoji" target="_blank" class="primarna-barva">
          tukaj
        </a>
        .
      </div>
      <div>
        <el-button
          :disabled="!vclanitev"
          class="gumb-potrdi gumb-vstopite-v-vklub"
          type="button" size="small"
          @click="VclaniVKlub">
          USTVARI KLUBSKI RAČUN
        </el-button>
      </div>
    </div>
    <hr class="hr-stil"/>
    <div class="postavitev-naslova" style="padding-top: 30px; clear: both">
      <p class="naslov">
        Kaj pridobite s članstvom v T-2 Klubu?
      </p>
    </div>
    <div class="grid-container">
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/MojT2/T2Klub/Klub_Tocke.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-aplikacije">
            <p class="open-sans-20pt">
              <b class="postavitev-naslova-aplikacije">
                Mimogrede do točk
              </b>
            </p>
            <p class="postavitev-besedila-klub navadno-besedilo">
              Člani T-2 Kluba prejmejo točke <b>ob vsakem plačanem računu</b>, za zvestobo in ob naročilu
              izdelkov. Pridobljene točke pa lahko uporabijo za nakup izdelkov ali storitev po nižji
              ceni v spletni trgovini T-2 Kluba.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/MojT2/T2Klub/ico-1.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-aplikacije">
            <p class="open-sans-20pt">
              <b class="postavitev-naslova-aplikacije">
                Odplačujte obročno

              </b>
            </p>
            <p class="postavitev-besedila-klub navadno-besedilo">
              Člani T-2 Kluba imajo
              <b>
                možnost nakupov na obroke, ki so izjemno dostopni,
              </b>
              brez nepotrebnih dokumentov za odobritev kredita, stroškov zavarovanja kredita
              in podobnih dokumentov, ki jih zahtevajo drugi prodajalci.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/MojT2/T2Klub/ico-3.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-aplikacije">
            <p class="open-sans-20pt">
              <b class="postavitev-naslova-aplikacije">
                Preizkusite nove storitve
              </b>
            </p>
            <p class="postavitev-besedila-klub navadno-besedilo">
              Vsem članom, ki so tudi naročniki T-2 storitev, omogočamo uporabo tistih storitev T-2,
              ki jih
              <b>
                še nimajo vključenih, za obdobje 3 mesecev
              </b>
              oz. za obdobje, določeno v klubski
              ponudbi, po izjemno ugodnih klubskih cenah.
            </p>
          </div>
        </div>
      </div>
      <div>
        <div class="levi-pomik-slika">
          <img src="/static/img/MojT2/T2Klub/ico-4.png" class="velikost-slike">
        </div>
        <div>
          <div class="pomik-besedila-aplikacije">
            <p class="open-sans-20pt">
              <b class="postavitev-naslova-aplikacije">
                Najhitrejša pot do želenih storitev
              </b>
            </p>
            <p class="postavitev-besedila-klub navadno-besedilo">
              Želene storitve, ki jih naročite, plačate in vklopite preko portala T-2 Kluba, so
              <b>
                vklopljene takoj po zaključku naročila.
              </b>
              Tako prihranite svoj čas in denar, saj z vsakim
              nakupom pridobivate nove točke za naslednje nakupe.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {Checkbox, Button, Option, Select, Pagination, TabPane, Tabs, MessageBox} from 'element-ui'

export default {
  name: 'ClanstvoKlubInfo',
  data () {
    return {
      klubUrl: '',
      stranUrl: '',
      splosniPogoji: '',
      vclanitev: false
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Pagination.name]: Pagination,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  props: {
    izbranaStranka: String
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.splosniPogoji = povezave.BASE_URL_SPLOSNI_POGOJI
    this.klubUrl = povezave.BASE_URL_T2_KLUB
    this.stranUrl = povezave.BASE_URL_T2_STRAN
  },
  methods: {
    VclaniVKlub () {
      if (this.izbranaStranka !== '') {
        MessageBox.confirm('Ali ste prepričani, da se želite včlaniti?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          let param = ['idStranka=' + this.izbranaStranka]
          this.clientAgent.postWsRequest(this,
            '/klub/klubVclani?',
            param,
            null,
            'SetVclaniVKlub',
            'ErrVclaniVKlub')
        }).catch((err) => {
          err = null
        })
      }
    },
    SetVclaniVKlub (podatki) {
      let paramObvestilo = {}
      this.$emit('ponovniKlicZaPridobivanjeVclanitve', this.izbranaStranka)
      paramObvestilo.message = 'Uspešno ste se včlanili v klub.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrVclaniVKlub (podatki) {
      let paramObvestilo = {}
      this.$emit('ponovniKlicZaPridobivanjeVclanitve', this.izbranaStranka)
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/T2Klub/ClanstvoKlubInfo.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/T2klub/ClanstvoKlubInfo.vue